import { Link } from 'react-router-dom';
import { useLocale } from '../../app/locale/LocaleProvider';
import { Locale } from '../../app/locale/resolveLocale';
import { landingCopy } from '../../data/resultCopy';

export function LandingPage({ forcedLocale }: { forcedLocale?: Locale }) {
  const { locale, setLocale } = useLocale();
  const activeLocale = forcedLocale ?? locale;
  const copy = landingCopy[activeLocale];
  const nextLocale: Locale = activeLocale === 'zh-CN' ? 'en' : 'zh-CN';
  const howItWorksPath = activeLocale === 'zh-CN' ? '/zh/how-it-works/' : '/en/how-it-works/';

  return (
    <main className="landing-page">
      <section className="landing-hero">
        <div className="landing-copy">
          <p className="landing-kicker">{copy.brand}</p>
          <h1>{copy.title}</h1>
          <p>{copy.subtitle}</p>
          <div className="landing-actions">
            <Link className="primary-link" to="/play">{copy.start}</Link>
            <a className="secondary-link" href={howItWorksPath}>{copy.howItWorks}</a>
            <button type="button" onClick={() => setLocale(nextLocale)}>
              {copy.languageToggle}
            </button>
          </div>
        </div>
        <div className="landing-art" aria-hidden="true">
          <img src="/assets/characters/joke_shield_deflector/hero.svg" alt="" className="landing-character primary" />
          <img src="/assets/characters/hidden_plot_twister/badge.svg" alt="" className="landing-badge top" />
          <img src="/assets/characters/clear_boundary_calm_repairer/badge.svg" alt="" className="landing-badge bottom" />
        </div>
      </section>
    </main>
  );
}
